// uiVersion (Connect) — GATE TENANT bọc quanh kernel dùng chung @cnv/ui/lib/uiVersion.
//
// Phần chung (luật mặc định, đọc/ghi localStorage, áp attribute, subscribe) nằm ở
// cnv-ui/src/lib/uiVersion.js vì cả Work SaaS lẫn Core cũng dùng — 1 nguồn sự thật.
// File này chỉ thêm thứ RIÊNG của một cụm SaaS: 1 cụm có nhiều tenant nên phải chặn được
// theo tenant; Core là 1 khách 1 deployment nên không có khái niệm này.
//
// Bản này là bản SONG SINH với cnvwork-saas/admin/src/lib/uiVersion.js — cố ý chép chứ
// không dùng chung: allowlist là quyết định VẬN HÀNH của từng cụm (cụm Connect muốn khoá
// v2 lại vì một khách kêu thì không được kéo theo cụm Work).

export {
  UI_VERSION_KEY,
  UI_V1,
  UI_V2,
  UI_VERSION_EVENT,
  isValidUiVersion,
  readStoredUiVersion,
  hasStoredUiVersion,
  applyUiVersion,
  setUiVersion,
} from '@cnv/ui/lib/uiVersion';

import {
  UI_V1,
  readUiVersion as readUiVersionBase,
  subscribeUiVersion as subscribeUiVersionBase,
} from '@cnv/ui/lib/uiVersion';

/**
 * TENANT ĐƯỢC PHÉP THẤY v2.
 *   null      = mở cho TẤT CẢ (trạng thái hiện tại)
 *   ['slug']  = chỉ những tenant liệt kê; tenant ngoài danh sách KHÔNG BAO GIỜ thấy v2,
 *               kể cả khi localStorage `ui_version` = 'v2' còn sót.
 *
 * ⚠️ Giá trị này LẶP ở IIFE boot trong admin/index.html (biến `ALLOW`) — boot script không
 * import được module mà vẫn phải gate ngay lúc boot để không nháy v2 rồi lật về v1.
 * Sửa ở đây PHẢI sửa cả bên đó.
 */
export const UI_V2_TENANT_ALLOWLIST = null;

/** Tenant này có được phép dùng v2 không. allowlist = null ⇒ mở cho tất cả. */
export function isTenantAllowed(slug) {
  if (UI_V2_TENANT_ALLOWLIST === null) return true;
  return !!slug && UI_V2_TENANT_ALLOWLIST.includes(slug);
}

/**
 * Phiên bản đang áp dụng.
 * @param {string} [tenantSlug] slug tenant đang mở. Truyền vào thì gate allowlist có hiệu lực;
 *   KHÔNG truyền (undefined) thì chỉ trả lựa chọn của user — chỉ dùng cho nơi chưa biết tenant.
 *   Chốt chặn thật nằm ở admin/src/components/AppLayout.jsx (nơi có activeTenant).
 */
export function readUiVersion(tenantSlug) {
  if (tenantSlug !== undefined && !isTenantAllowed(tenantSlug)) return UI_V1;
  return readUiVersionBase();
}

/** Như bản kernel, nhưng KHÔNG cho tab khác lách qua gate tenant. */
export function subscribeUiVersion(cb) {
  return subscribeUiVersionBase(cb, () => readUiVersion());
}
